import React, { useState, useEffect } from "react"
import Modal from "aldoo-ra/Modal"
import ContentEditor from "aldoo-ra/CMS/content-editor"
import { GetCMSType, SaveCMSContent } from "aldoo-ra/CMS/api"
import { getNode } from "../api"

export default function NodePropertiesPanel({ slug, onClose, onSaved }) {
  const [node, setNode] = useState(null)
  const [contentType, setContentType] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!slug) return
    setLoading(true)
    Promise.all([
      getNode(slug),
      GetCMSType({ match: { "content.type": "TaxonomyNode" }, itemsPerPage: 1 }),
    ])
      .then(([nodeRes, typeRes]) => {
        setNode(nodeRes?.content ?? null)
        const rawType = typeRes?.data?.[0]
        setContentType(rawType ? { ...rawType.content, _id: rawType._id } : null)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [slug])

  const handleSave = async (values) => {
    if (!node) return
    await SaveCMSContent({
      _id: node._id,
      content: { ...node.content, ...values },
      localization: node.localization,
    })
    onSaved?.()
    onClose()
  }

  return (
    <Modal
      isOpen={!!slug}
      onClose={onClose}
      title="Node Properties"
      variant="admin_drawer_right"
      closeOnClickOutside
      className="w-[800px]"
    >
      {loading && (
        <div className="flex items-center justify-center h-48 text-admin_text_dim text-sm">
          Loading...
        </div>
      )}
      {!loading && (!node || !contentType) && (
        <div className="flex items-center justify-center h-48 text-admin_text_dim text-sm">
          Failed to load node
        </div>
      )}
      {!loading && node && contentType && (
        <ContentEditor
          dataItem={node}
          contentType={contentType}
          fieldValues={node.content}
          onSave={handleSave}
          onClickSave={() => {}}
          clearValuesAfterSave={false}
          onClose={onClose}
        />
      )}
    </Modal>
  )
}
